<template>
  <el-table-column :key="column.prop" v-bind="{ showOverflowTooltip: true, ...column }">
    <template v-for="item in column.children">
      <mg-table-column v-if="item.children && item.children.length" :key="item.prop" :column="item" />
      <el-table-column
        v-else-if="item.slot && !item.hidden"
        :key="item.prop"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :align="item.align"
        :header-align="item.headerAlign"
        :prop="item.prop"
        :sortable="item.sortable"
        :sort-by="item.sortBy"
        :fixed="item.fixed"
        :formatter="item.formatter"
        :show-overflow-tooltip="item.showOverflowTooltip ?? true"
        :class-name="getColumnClassName(item)"
      >
        <!-- 自定义列内容 -->
        <template #default="scope">
          <slot :name="item.slot" v-bind="scope" />
        </template>
      </el-table-column>
      <el-table-column v-else :key="item.prop" v-bind="{ showOverflowTooltip: true, ...item }" />
    </template>
  </el-table-column>
</template>

<script>
  export default {
    name: 'MgTableColumn',
    props: {
      column: Object,
    },
    methods: {
      getColumnClassName(column) {
        return column.headerModel ? 'el-table_searchable_column' : column.className
      },
    },
  }
</script>
